import { Box, Flex, HelpHover, InputContainer, LockClosedIcon, Menu, Text } from 'components'
import { useTemplates } from 'utils/templateUtils'
import { useEvent } from '../../../utils/eventUtils'
import { PartialTemplate } from '../../../utils/momentUtils'

interface Props {
  value?: string
  onChange: (moment: PartialTemplate) => void
}

export default function MomentsTemplateSelect({ value, onChange }: Props) {
  const { templates } = useTemplates()
  const { event } = useEvent()

  if (!event) return null

  const { sessionCount } = event

  return (
    <InputContainer label="Template" required={!!templates?.length} position="relative">
      <Flex align="center" gap={2}>
        <Menu
          variant="outline"
          disabled={Boolean(sessionCount) || templates?.length === 0}
          value={value}
          onChange={id => onChange(templates!.find(t => t.id === id)!)}
          buttonLabel={
            templates?.find(t => t.id === value)?.title ||
            (templates?.length === 0 ? 'No templates available' : 'Select a template')
          }
          contentProps={{ width: '408px' }}
          menuProps={{ positioning: { placement: 'top-start' } }}
          options={
            templates?.map(t => ({
              value: t.id,
              label: (
                <Box>
                  <Text>{t.title}</Text>
                  <Text lineClamp={2} textStyle="bodyXSmall" opacity={0.6}>
                    {t.description.en}
                  </Text>
                </Box>
              ),
            })) || []
          }
        />
        {Boolean(sessionCount) && (
          <>
            <LockClosedIcon color="red" type="outline" size="sm" />
            <HelpHover
              text="Can't change template once sessions have been captured. Delete existing sessions to update."
              borderRadius="5px"
              iconProps={{ size: 'sm' }}
            />
          </>
        )}
      </Flex>
    </InputContainer>
  )
}
